import { useEffect, useRef, useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";
import axios from "axios";
import MessageToster from "../component/MessageToster";
import { BASE_URL } from "../api";
import Loader from "../component/Loader";
import { closeModal } from "../utils/modal";
import { useHandleError } from "../hooks/useHandleError";
import { getApiHeaders } from "../utils/helpers";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import { exportToExcel } from "../utils/exportData";
import ExportButton from "../component/ExportButton";
import MobileFilter from "../component/MobileFilter";

export default function Tickets() {
  const fileUpload = useRef(null);
  const handleError = useHandleError();

  const [input, setInput] = useState({
    title: "",
    priority: "",
    department: "",
    note: "",
    attachment: ""
  });
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    status: "All"
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  // const [verror, setVerror] = useState("");

  const [validations, setValidations] = useState({
    title: "",
    priority: "",
    department: "",
    note: "",
    attachment: ""
  });

  const validationRules = {
    title: "Subject is required.",
    priority: "Priority is required.",
    department: "Department is required.",
    note: "Description is required.",
    attachment: "Attachment is required."
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (type === "file" && files.length > 0) {
      setInput((prev) => ({
        ...prev,
        [name]: files[0]
      }));
    } else {
      setInput((prev) => ({
        ...prev,
        [name]: value
      }));
    }

    setValidations((prev) => ({
      ...prev,
      [name]: false
    }));
  };

  const handleReset = () => {
    setInput({
      title: "",
      priority: "",
      department: "",
      note: "",
      attachment: ""
    });
    setValidations({
      title: "",
      priority: "",
      department: "",
      note: "",
      attachment: ""
    });
    // setVerror("");

    if (fileUpload.current) {
      fileUpload.current.value = "";
    }
  };

  const handleSearch = () => {
    let result = [...tickets];
    if (filters.fromDate) {
      const from = new Date(filters.fromDate);
      from.setHours(0, 0, 0, 0);
      result = result.filter((item) => {
        const itemDateStr = item.ondate ? String(item.ondate).split(" ")[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate >= from;
      });
    }
    if (filters.toDate) {
      const to = new Date(filters.toDate);
      to.setHours(23, 59, 59, 999);
      result = result.filter((item) => {
        const itemDateStr = item.ondate ? String(item.ondate).split(" ")[0] : "";
        const itemDate = new Date(itemDateStr);
        return itemDate <= to;
      });
    }
    if (filters.status && filters.status !== "All") {
      result = result.filter(
        (item) => item.status?.toLowerCase() === filters.status.toLowerCase()
      );
    }
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      result = result.filter((item) => {
        return (
          String(item.ticketno || "").toLowerCase().includes(searchLower) ||
          String(item.priority || "").toLowerCase().includes(searchLower) ||
          String(item.department || "").toLowerCase().includes(searchLower) ||
          String(item.status || "").toLowerCase().includes(searchLower)
        );
      });
    }
    setFilteredTickets(result);
  };

  const clearFilters = () => {
    setFilters({
      fromDate: "",
      toDate: "",
      status: "All"
    });
    setSearchTerm("");
    setFilteredTickets(tickets);
  };

  const onSubmitForm = () => {
    for (const field in input) {
      if (field === "attachment" && !input[field]) continue;

      if (!input[field]) {
        setValidations((prev) => ({ ...prev, [field]: true }));
        // setVerror(validationRules[field]);
        return;
      }
    }
    setLoading(true);
    AddTicket();
  };

  const AddTicket = async () => {
    const dataofmid = sessionStorage.getItem('mid');
    const formData = new FormData();
    formData.append("mid", Number(dataofmid));
    formData.append("title", input.title);
    formData.append("priority", input.priority);
    formData.append("department", input.department);
    formData.append("note", input.note);
    if (input.attachment) {
      formData.append("attachment", input.attachment);
    }

    try {
      const res = await axios.post(`${BASE_URL}/support/raise_ticket`, formData, { headers: getApiHeaders(true) });

      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        closeModal()
        handleReset();
        getTickets();
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getTickets = async () => {
    setLoading(true)
    const dataofmid = sessionStorage.getItem("mid");
    const bodyData = {
      mode: "",
      mid: Number(dataofmid)
    }
    try {
      const response = await axios.post(`${BASE_URL}/support/get_all_ticket`, bodyData, { headers: getApiHeaders() });

      // if (response.data.code === 200) {
      //   setLoading(false);
      //   const raw = response.data.message;
      //   const normalized = Array.isArray(raw) ? raw : [raw];

      //   setTickets(normalized);
      // } else {
      //   setLoading(false)
      //   MessageToster("error", response.data.message)
      // }
      if (response.data.code === 200) {
        const raw = response.data.message;
        const normalized = Array.isArray(raw)
          ? raw.filter(t => t.ticketno)
          : (raw && raw.ticketno ? [raw] : []);

        setTickets(normalized);
        setFilteredTickets(normalized);
      } else if (
        response.data.code === 400 &&
        Array.isArray(response.data.message) &&
        response.data.message[0]?.msg === "No ticket found this user"
      ) {
        setTickets([]);
        setFilteredTickets([]);
        MessageToster("error", "No tickets found for this user.");

      } else {
        MessageToster("error", response.data.message);
      }

    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { getTickets(); }, []);

  // useEffect(() => {
  //   if (tickets.length > 0) {
  //     if (!window.$.fn.DataTable.isDataTable(tableRef.current)) {
  //       displayButtons(tableRef);
  //     }
  //   }
  // }, [tickets]);




  return (
    <>
      <div id="layout-wrapper">
        {loading &&
          <Loader />}
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-0">Tickets</h2>
                    <div className="page-title-right">
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        data-bs-toggle="modal"
                        data-bs-target=".bs-example-modal-center"
                        onClick={handleReset}
                      >
                        New Ticket
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="fromDate"
                            value={filters.fromDate}
                            max={filters.toDate || new Date().toISOString().split("T")[0]}
                            onChange={(e) => setFilters(prev => ({...prev, fromDate: e.target.value}))}
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="toDate"
                            value={filters.toDate}
                            min={filters.fromDate || undefined}
                            max={new Date().toISOString().split("T")[0]}
                            onChange={(e) => setFilters(prev => ({...prev, toDate: e.target.value}))}
                          />
                        </div>
                        <div>
                          <label htmlFor="">Status</label>
                          <select
                            className="form-select"
                            name="status"
                            value={filters.status}
                            onChange={(e) => setFilters(prev => ({...prev, status: e.target.value}))}
                          >
                            <option value="All">All</option>
                            <option value="Open">Open</option>
                            <option value="Replied">Replied</option>
                            <option value="Close">Close</option>
                          </select>
                        </div>
                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={handleSearch}
                          >
                            Search
                          </button>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && filters.status === "All" && !searchTerm}
                          >
                            Clear
                          </button>
                        </div>
                        <div className="ms-auto">
                          <ExportButton
                            onClick={() => exportToExcel(filteredTickets, "tickets_report", "tickets")}
                          />
                        </div>
                      </div>

                      <MobileFilter
                        title="History"
                        onExport={() => exportToExcel(filteredTickets, "tickets_report", "tickets")}
                      >
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="fromDate"
                            value={filters.fromDate}
                            max={filters.toDate || new Date().toISOString().split("T")[0]}
                            onChange={(e) => setFilters(prev => ({...prev, fromDate: e.target.value}))}
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="toDate"
                            value={filters.toDate}
                            min={filters.fromDate || undefined}
                            max={new Date().toISOString().split("T")[0]}
                            onChange={(e) => setFilters(prev => ({...prev, toDate: e.target.value}))}
                          />
                        </div>
                        <div>
                          <label htmlFor="">Status</label>
                          <select
                            className="form-select"
                            name="status"
                            value={filters.status}
                            onChange={(e) => setFilters(prev => ({...prev, status: e.target.value}))}
                          >
                            <option value="All">All</option>
                            <option value="Open">Open</option>
                            <option value="Replied">Replied</option>
                            <option value="Close">Close</option>
                          </select>
                        </div>
                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                        <div className="d-flex gap-2 mt-2">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light flex-grow-1"
                            onClick={handleSearch}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            className="btn btn-light waves-effect waves-light border flex-grow-1"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && filters.status === "All" && !searchTerm}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Clear
                          </button>
                        </div>
                      </MobileFilter>
                      <CommonTable
                        columns={[
                          { header: "Ticket No", accessor: "ticketno" },
                          { header: "Priority", accessor: "priority" },
                          { header: "Department", accessor: "department" },
                          { header: "Created Date", render: (row) => row.ondate ? formatDateDDMMYYYY(row.ondate) : "" },
                          { header: "Closed Date", render: (row) => row.closed_date ? formatDateDDMMYYYY(row.closed_date) : "" },
                          {
                            header: "Status",
                            render: (row) => (
                              <button className={`btn btn-sm ${row.status === "Open"
                                ? "btn-soft-success"
                                : row.status === "Replied"
                                  ? "btn-soft-warning"
                                  : row.status === "Close"
                                    ? "btn-soft-danger"
                                    : ""
                                }`}>{row.status}</button>
                            )
                          },
                          {
                            header: "Action",
                            render: (row) => (
                              <a href={`/ticketinformation?id=${row.id}`} className="btn btn-sm btn-soft-primary">
                                <i className="mdi mdi-eye-outline fs-5"></i>
                              </a>
                            )
                          }
                        ]}
                        data={filteredTickets}
                        loading={loading}
                      />
                    </div>
                  </div>
                </div>{" "}
                {/* end col */}
                <div>
                  {/* modal */}
                  <div
                    className="modal fade bs-example-modal-center"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" onClick={handleReset}> New Ticket</h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleReset}
                          />
                        </div>

                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            onSubmitForm();
                          }}
                        >
                          <div className="modal-body">
                            <div className="row">
                              {/* Title */}
                              <div className="col-12 mb-3">
                                <label className="form-label">
                                  Subject <span className="text-danger">*</span>
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="title"
                                  placeholder="Enter subject"
                                  value={input.title}
                                  onChange={handleChange}
                                />
                                {validations.title && (
                                  <p className="text-danger mb-0">{validationRules.title}</p>
                                )}
                              </div>

                              {/* Priority */}
                              <div className="col-12 mb-3">
                                <label className="form-label">
                                  Priority <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  name="priority"
                                  value={input.priority}
                                  onChange={handleChange}
                                >
                                  <option value="" disabled hidden>Select an Option</option>
                                  <option value="Low">Low</option>
                                  <option value="Normal">Normal</option>
                                  <option value="High">High</option>
                                  <option value="Urgent">Urgent</option>
                                </select>
                                {validations.priority && (
                                  <p className="text-danger mb-0">{validationRules.priority}</p>
                                )}
                              </div>

                              {/* Department */}
                              <div className="col-12 mb-3">
                                <label className="form-label">
                                  Department <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  name="department"
                                  value={input.department}
                                  onChange={handleChange}
                                >
                                  <option value="" disabled hidden>Select an Option</option>
                                  <option value="Support">Support</option>
                                  <option value="Deposit">Deposit</option>
                                  <option value="Withdraw">Withdraw</option>
                                  <option value="Partners">Partners</option>
                                  <option value="Live Account">Live Account</option>
                                  <option value="Other">Other</option>
                                </select>
                                {validations.department && (
                                  <p className="text-danger mb-0">{validationRules.department}</p>
                                )}
                              </div>

                              {/* Description */}
                              <div className="col-12 mb-3">
                                <label className="form-label">
                                  Description <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  className="form-control"
                                  name="note"
                                  rows={3}
                                  placeholder="Enter description"
                                  value={input.note}
                                  onChange={handleChange}
                                />
                                {validations.note && (
                                  <p className="text-danger mb-0">{validationRules.note}</p>
                                )}
                              </div>

                              {/* Attachment */}
                              <div className="col-12">
                                <label className="form-label">Attachment</label>
                                <input
                                  id="inputGroupFile02"
                                  type="file"
                                  name="attachment"
                                  className="form-control"
                                  onChange={handleChange}
                                  ref={fileUpload}
                                />
                                <p className="mt-2 text-primary mb-0">
                                  File Supported: jpeg, jpg, png, pdf &amp; max File size: 5MB
                                </p>
                                {validations.attachment && (
                                  <p className="text-danger mb-0">{validationRules.attachment}</p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={handleReset}
                            >
                              Reset
                            </button>
                            <button type="submit" className="btn btn-primary">
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /.modal */}
                </div>
              </div>
            </div>
            {/* container-fluid */}
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
